/**
 * @desc getModeBySupplierIdNames
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/srm/getModeBySupplierIdNames`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
